import { useEffect } from 'react'
import { X, CheckCircle, AlertCircle, Info, Activity } from 'lucide-react'
import { useNotifications } from '../../context/NotificationContext'

const Notification = () => {
  const { notifications, removeNotification } = useNotifications()

  return (
    <div className="fixed top-20 right-4 z-40 space-y-2 pointer-events-none">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  )
}

const NotificationItem = ({ notification, onClose }) => {
  const icons = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
    default: Activity,
  }

  const colors = {
    success: 'border-green-300',
    error: 'border-red-300',
    info: 'border-blue-300',
    default: 'border-line',
  }

  const Icon = icons[notification.type] || icons.default
  const colorClass = colors[notification.type] || colors.default

  useEffect(() => {
    const timer = setTimeout(onClose, 5000)
    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div
      className={`bg-surface/90 backdrop-blur-sm shadow-lg border ${colorClass} rounded-lg p-3 flex items-center gap-3 animate-slideIn max-w-xs pointer-events-auto`}
    >
      <Icon className="w-4 h-4 text-accent-2 animate-pulse" />
      <div className="flex-1">
        <p className="text-sm text-ink">{notification.message}</p>
        <p className="text-xs text-ink-3">
          {notification.time.toLocaleTimeString()}
        </p>
      </div>
      <button
        onClick={onClose}
        className="text-ink-3 hover:text-ink-2 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}

export default Notification
